import { z } from 'zod';

// ── Full tenure (server → client) ─────────────────────────────────────────────

export const TenureSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  company: z.string(),
  startDate: z.string().nullable(),   // YYYY-MM-DD
  endDate: z.string().nullable(),     // YYYY-MM-DD; null = current / ongoing
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

// ── Create request (client → server) ─────────────────────────────────────────

export const CreateTenureSchema = z.object({
  company: z.string().min(1, 'Company is required').max(200).trim(),
  startDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD')
    .optional(),
  endDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD')
    .optional(),
});

// ── Update request — all fields optional; null clears a date field ───────────

export const UpdateTenureSchema = CreateTenureSchema.partial().extend({
  // Allow null to explicitly clear a date (e.g. "currently employed here").
  // undefined means "don't touch this field".
  startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD').nullable().optional(),
  endDate:   z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD').nullable().optional(),
});

// ── Derived types ─────────────────────────────────────────────────────────────

export type Tenure = z.infer<typeof TenureSchema>;
export type CreateTenure = z.infer<typeof CreateTenureSchema>;
export type UpdateTenure = z.infer<typeof UpdateTenureSchema>;
